import { alpha, Theme } from "@mui/material/styles";

/**
 * Shared look for the price / markup / indent inputs: one height, right-aligned
 * tabular numbers so a column of prices lines up, no spinner arrows, and a
 * validated value stays fully readable (tinted green) instead of greyed out.
 */
export const numberFieldSx = (validated: boolean, width: number) => (theme: Theme) => ({
  width,
  flexShrink: 0,
  "& .MuiOutlinedInput-root": {
    height: 34,
    fontSize: "0.875rem",
    paddingLeft: "8px",
    paddingRight: "8px",
    backgroundColor: validated ? alpha(theme.palette.success.main, 0.07) : theme.palette.background.paper,
    "& fieldset": {
      borderColor: validated ? alpha(theme.palette.success.main, 0.45) : alpha(theme.palette.text.primary, 0.2),
    },
    "&.Mui-disabled": {
      backgroundColor: validated ? alpha(theme.palette.success.main, 0.07) : theme.palette.action.hover,
    },
    "&.Mui-disabled fieldset": {
      borderColor: validated ? alpha(theme.palette.success.main, 0.45) : theme.palette.divider,
    },
  },
  "& .MuiInputBase-input": {
    textAlign: "right",
    fontVariantNumeric: "tabular-nums",
    padding: "6px 0",
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: validated ? theme.palette.text.primary : theme.palette.text.secondary,
  },
  "& .MuiInputAdornment-root": { color: theme.palette.text.secondary },
  "& .MuiInputAdornment-root .MuiTypography-root": { fontSize: "0.8125rem" },
  "& input[type=number]": { MozAppearance: "textfield" },
  "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
});

/** Click-to-edit text: the hover tint is drawn in the padding so the text never shifts. */
export const editableTextSx = {
  cursor: 'pointer',
  flex: 1,
  mx: -0.5,
  px: 0.5,
  borderRadius: 1,
  '&:hover': { bgcolor: 'action.hover' },
} as const;

export const switchLabelSx = { fontSize: "0.8125rem", whiteSpace: "nowrap" } as const;
